import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from "react-router-dom";
import "react-calendar/dist/Calendar.css";
import "./BusinessPublicProfile.css"
import "./BusinessProfileEditor.css"
import PublicImages from './PublicImages';
import ContactMap from './ContactMap';
import Navbar from "./Navbar"
import NotFound from "./NotFound"
import { useAuth } from '../context/AuthContext';





const BusinessPublicProfile = () => {
  const { businessId } = useParams();
  const [publicData, setPublicData] = useState([]);
  const [active, setActive] = useState(false)
  const [loading, setLoading] = useState(true)
  const [bookingData, setBookingData] = useState({})
  const [coverImage, setCoverImage] = useState({})
  const { businessAdminToken, businessToken} = useAuth()
  const [filtersex, setFiltersex] = useState("")


  useEffect(() => {
    const fetchPublicData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/business/public/${businessId}`);
        setPublicData(response.data);
        setLoading(false)
        setActive(false)
      } catch (err) {
        console.log(err.response?.data.message || err.message);
        setLoading(false)
        setActive(true)
      }
    };
    fetchPublicData();
  }, [businessId]);

  useEffect(() => {
    if (businessAdminToken) {
         const fetchPublicData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/business/public/${businessId}/private`,{
            headers: {
                Authorization: `Bearer ${businessAdminToken}`
            }
        });
        setPublicData(response.data);
        setLoading(false)
        setActive(false)
        

      } catch (err) {
        console.log(err.response?.data.message || err.message);
        setLoading(false)
        setActive(true)
      }
    };
    fetchPublicData();
    } else if (businessToken) {

        const fetchPublicData = async () => {
     try {
       const response = await axios.get(`${process.env.REACT_APP_API_URL}/business/public/${businessId}/business`,{
           headers: {
               Authorization: `Bearer ${businessToken}`
           }
       });
       setPublicData(response.data);
       setLoading(false)
       setActive(false)

     } catch (err) {
       console.log(err.response?.data.message || err.message);
       setLoading(false)
       setActive(true)
     }
   };
   fetchPublicData();
  
   }
  }, [businessId, businessAdminToken, businessToken]);
    
   
  useEffect(() => {
    console.log(publicData.coverImage)
    console.log(coverImage)
  }, [publicData.coverImage, coverImage])
  

  useEffect(() => {
    if (businessId) {
        try {
            const fetchCoverImage = async () => {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/images/public-images`, {
                    params: {businessId, isCover: "true"}
                })
                setCoverImage(response.data.images[0])
            }
            fetchCoverImage()
        } catch (err) {
            console.log(err.response?.data?.message)
        }
    }
  }, [businessId])



  useEffect(() => {
    if (publicData.hotelReservation) {
        try {
        const fetchBookingData = async () => {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/booking/public`, {
                params: {business: businessId}
            })
            setBookingData(response.data.data)
            
        }
        fetchBookingData()
      } catch (err) {
        console.log(err.response?.data?.message)
      }     
    }
  }, [businessId, publicData.hotelReservation])
  
  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    scrollToTop()
  }, [])


  if (loading) {
    return <div className='min-height'>
        <Navbar />
        <div className='loading-spinner center-spinner'>

        </div>
    </div>
  }
  if (active) {
    return <NotFound />

  }
  
  return (<div>
    {/* Business container před obrázky */}
    <Navbar businessId={businessId} publicName={publicData?.name}/>
    
        {publicData && (
            <div>
              {publicData.coverImage && coverImage?.fileUrl ? (
                <div className="cover-container">
                    <div className="cover-image">
                        <img src={`${coverImage?.fileUrl}`} alt="cover-image" />
                        <div className="cover-header">
                            <h2 className="cover-name">{publicData.name}</h2>
                            <h2 className="cover-owner">{publicData.owner}</h2>
                            <h4 className="cover-type">{publicData.businessType}</h4>
                        </div>
                    </div>
                </div>
              ) : (
                <div className="business-header">
                    <h2 className="business-name">{publicData.name}</h2>
                    <h2 className="business-owner">{publicData.owner}</h2>
                    <h4 className="business-type">{publicData.businessType}</h4>
                </div>
              )
            }
            <div className="business-container">
                {publicData.visibleDescription && (
                    <div
                        dangerouslySetInnerHTML={{ __html: publicData.description?.replace(/<p><\/p>/g, "<br />") }}
                        className="business-description"
                    />
                )}
            <div className="reservation-container">
              <Link to={`/business/public/${businessId}/reservation`} className="submit-button">
                Rezervace termínu
              </Link>
            </div>
            </div>

                {publicData.visibleServices && (
                    <div className="services-container">
                        <h2 className="services-title">Služby</h2>
                        <select
                            className='basic-input reservation-select'
                            value={filtersex}
                            onChange={(e) => setFiltersex(e.target.value)}
                        >
                            <option value="">Všechny služby</option>
                            <option value="everyone">Všichni</option>
                            <option value="female">Ženy</option>
                            <option value="male">Muži</option>
                            <option value="children">Děti</option>
                        </select>
                        {
                            Array.isArray(publicData.services) &&
                            publicData.services
                            .filter(service => {
                                if (!filtersex) return true
                                return service.sex === filtersex
                            })
                            .sort((a, b) => a.order - b.order)
                            .map((service) => {                           
                                return(
                                <div key={service._id} className="service-item">
                                    <div className="all-service-description">
                                        <h4 className="service-name">{service.name}</h4>
                                        <p className="service-description">{service.description}</p>
                                    </div>
                                    <div className='service-sex-div'>
                    {service.sex ? <p className='service-sex'>{service.sex === "everyone" ? "Všichni"
                     : service.sex === "female" ? "Ženy"
                     : service.sex === "male" ? "Muži"
                     : service.sex === "children" ? "Děti"
                     : ""                
                     }</p> : <p className='service-sex-nothing'></p> } 
                  </div>
                                    <div className="all-service-price">
                                        <p className="service-duration">{service.duration} minut</p>
                                        <p className="service-price">{service.price} Kč</p>
                                    </div>
                                </div>
                            )})
                        }
                       
                        <div className="reservation-container">
                            <Link to={`/business/public/${businessId}/reservation`} className="submit-button">
                                Rezervace termínu
                            </Link>
                        </div>
                    </div>
                )}
            </div>
        )}
    

    {/* Samostatný div pro obrázky */}
    {publicData?.visiblePhoto && <PublicImages />}

    {/* Business container pokračuje po obrázcích */}
    
        {publicData.visibleWorkHours && (

                <div className="work-hours-container">
                    <h2 className='services-title'>Otevírací doba</h2>
                    {publicData.workHours?.map((workHour, index) => (
                        <div key={index} className="work-hour-item">
                            <p className="work-hour-day">{workHour.day}</p>
                            {workHour.start !== workHour.end ? (
                                <p className="work-hour-time">{workHour.start} - {workHour.end}</p>
                            ) : (
                                <p className="work-hour-closed">Zavřeno</p>
                            )}
                        </div>
                    ))}
                </div>

        )}

<div className='business-container'>
    {publicData.hotelReservation && <div className='Booking-info-container'>
        <h2 className='booking-title'>Info k pobytu</h2>
            <div className="booking-item">
                <h4 className="booking-name">Check-In:</h4>
                <p className="booking-description">{bookingData?.checkInTime || ""}</p>
            </div>
            <div className="booking-item">
                <h4 className="booking-name">Check-Out:</h4>
                <p className="booking-description">{bookingData?.checkOutTime || ""}</p>
            </div>
            <div className="booking-item">
                <h4 className="booking-name">Max. osob:</h4>
                <p className="booking-description">{bookingData?.maxPeople || ""}</p>
            </div>
            <div className="booking-item">
                <h4 className="booking-name">Cena za noc:</h4>
                <p className="booking-description">{bookingData?.pricePerNight || ""} Kč</p>
            </div>
            <div className="booking-item">
                <h4 className="booking-name">Cena za úklid:</h4>
                <p className="booking-description">{bookingData?.cleaningFee || ""} Kč/pobyt</p>
            </div>
            <div className="booking-item">
                <h4 className="booking-name">Zvířata:</h4>
                <p className="booking-description">{bookingData?.pet === true ? "Povolena" : "Nepovolena"}</p>
            </div>
            {bookingData.pet && <div className="booking-item">
                <h4 className="booking-name">Poplatek za zvíře:</h4>
                <p className="booking-description">{bookingData?.petFee || ""} Kč/pobyt</p>
            </div>}
            {bookingData.deposit && <div className="booking-item">
                <h4 className="booking-name">Záloha:</h4>
                <p className="booking-description">{bookingData?.deposit || ""} %</p>
            </div>}
        </div>
        }
        
            <div className="reservation-container">
                <Link to={`/business/public/${businessId}/reservation`} className="submit-button">
                     Rezervace termínu
                </Link>
            </div>
        </div>
                                
    
    <div className="contact-container">
    {publicData.visibleCompanyData && <div className="contact-info-container">
            <p className="contact-email">Email: {publicData.email}</p>
            <p className="contact-phone">Telefon: {publicData.phone}</p>
            <p className="contact-address">
                Adresa: {publicData.street} {publicData.houseNumber}, {publicData.city}, {publicData.postalCode}, {publicData.country}
            </p>
            <a 
                href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(publicData.street + ' ' + publicData.houseNumber + ', ' + publicData.city + ', ' + publicData.postalCode + ', ' + publicData.country)}`} 
                target="_blank" 
                rel="noopener noreferrer"
                className="contact-route-link"
            >
                Zobrazit trasu
            </a>
        </div>}
  <div className="contact-map-container">
    {publicData.visibleMap && <ContactMap publicData={publicData} />}
  </div>
</div>
</div>
  );
};

export default BusinessPublicProfile